import { Steps, StepProps, StepItem } from "antd";
import styled from "styled-components";

export const StyledSteps = styled(Steps)`
  .ant-steps-item-icon {
    background: var(--main-color);
    width: 16px;
    height: 16px !important;
    margin-top: 4px;
  }
  .ant-steps-item-finish .ant-steps-item-icon,
  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    border-color: var(--main-color);
  }
  .ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-icon {
    background: var(--main-color);
  }
  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-icon
    .ant-steps-icon,
  .ant-steps-item-wait .ant-steps-item-icon > .ant-steps-icon,
  .anticon {
    display: none;
  }
  .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
    color: var(--main-color);
    height: 16px;
    line-height: 16px;
    display: block;
    left: -8px;
    top: -2px;
  }
  .ant-steps-item-custom.ant-steps-item-process
    .ant-steps-item-icon
    > .ant-steps-icon {
    height: 16px;
    line-height: 16px;
    display: block;
    text-align: left;
  }
  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    display: none;
  }
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after,
  .ant-steps-vertical
    > .ant-steps-item
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    background: var(--main-color);
    width: 2px;
  }
  .ant-steps-item-tail {
    padding-top: 28px !important;
    left: 8px !important;
  }
  .ant-steps-vertical > .ant-steps-item {
    height: 100px;
  }
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title,
  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-title {
    color: #d4d4d4;
    font-size: 14px;
    line-height: 22px;
    padding-bottom: 4px;
  }
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-description,
  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-description,
  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-content
    > .ant-steps-item-description {
    color: #e0e1e1;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    height: 110px;
  }
  .ant-steps-vertical.ant-steps-dot .ant-steps-item-content {
    padding-left: 10px;
  }
  .ant-steps-item-process
    > .ant-steps-item-container
    > .ant-steps-item-tail::after,
  .ant-steps-item-wait
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
    width: 2px;
    background: #656f72;
  }
  .ant-steps-item-wait .ant-steps-item-icon {
    background-color: #656f72 !important;
  }
`;
